import { IMPORT_TOOLS, IMPORT_TOOL_ROUTE } from 'modules/importTool/importTool.constants';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImportToolMenu from 'modules/importTool/importToolMenu.component';
import React from 'react';

// The import tool page lists the tools, and each tool has its own page under it. Unknown tool paths go back to the list.
const ImportToolLayout = () => (
  <Switch>
    <Route exact path={IMPORT_TOOL_ROUTE} component={ImportToolMenu} />
    {IMPORT_TOOLS.map(tool => (
      <Route key={tool.route} exact path={tool.route} component={tool.component} />
    ))}
    <Redirect to={IMPORT_TOOL_ROUTE} />
  </Switch>
);

export default ImportToolLayout;
